// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file notification_templates/v1/notification_templates.proto (package notification_templates.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file notification_templates/v1/notification_templates.proto.
 */
export const file_notification_templates_v1_notification_templates: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_google_protobuf_struct],
	);

/**
 * @generated from message notification_templates.v1.NotificationTemplate
 */
export type NotificationTemplate = Message<"notification_templates.v1.NotificationTemplate"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string content = 2;
	 */
	content: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;
};

/**
 * @generated from message notification_templates.v1.NotificationTemplate
 */
export type NotificationTemplateJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string content = 2;
	 */
	content?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;
};

/**
 * Describes the message notification_templates.v1.NotificationTemplate.
 * Use `create(NotificationTemplateSchema)` to create a new message.
 */
export const NotificationTemplateSchema: GenMessage<NotificationTemplate, { jsonType: NotificationTemplateJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 0);

/**
 * @generated from message notification_templates.v1.GetTemplateRequest
 */
export type GetTemplateRequest = Message<"notification_templates.v1.GetTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message notification_templates.v1.GetTemplateRequest
 */
export type GetTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message notification_templates.v1.GetTemplateRequest.
 * Use `create(GetTemplateRequestSchema)` to create a new message.
 */
export const GetTemplateRequestSchema: GenMessage<GetTemplateRequest, { jsonType: GetTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 1);

/**
 * @generated from message notification_templates.v1.GetTemplateResponse
 */
export type GetTemplateResponse = Message<"notification_templates.v1.GetTemplateResponse"> & {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplate;
};

/**
 * @generated from message notification_templates.v1.GetTemplateResponse
 */
export type GetTemplateResponseJson = {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplateJson;
};

/**
 * Describes the message notification_templates.v1.GetTemplateResponse.
 * Use `create(GetTemplateResponseSchema)` to create a new message.
 */
export const GetTemplateResponseSchema: GenMessage<GetTemplateResponse, { jsonType: GetTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 2);

/**
 * @generated from message notification_templates.v1.CreateTemplateRequest
 */
export type CreateTemplateRequest = Message<"notification_templates.v1.CreateTemplateRequest"> & {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplate;
};

/**
 * @generated from message notification_templates.v1.CreateTemplateRequest
 */
export type CreateTemplateRequestJson = {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplateJson;
};

/**
 * Describes the message notification_templates.v1.CreateTemplateRequest.
 * Use `create(CreateTemplateRequestSchema)` to create a new message.
 */
export const CreateTemplateRequestSchema: GenMessage<CreateTemplateRequest, { jsonType: CreateTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 3);

/**
 * @generated from message notification_templates.v1.CreateTemplateResponse
 */
export type CreateTemplateResponse = Message<"notification_templates.v1.CreateTemplateResponse"> & {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplate;
};

/**
 * @generated from message notification_templates.v1.CreateTemplateResponse
 */
export type CreateTemplateResponseJson = {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplateJson;
};

/**
 * Describes the message notification_templates.v1.CreateTemplateResponse.
 * Use `create(CreateTemplateResponseSchema)` to create a new message.
 */
export const CreateTemplateResponseSchema: GenMessage<CreateTemplateResponse, { jsonType: CreateTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 4);

/**
 * @generated from message notification_templates.v1.UpdateTemplateRequest
 */
export type UpdateTemplateRequest = Message<"notification_templates.v1.UpdateTemplateRequest"> & {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplate;
};

/**
 * @generated from message notification_templates.v1.UpdateTemplateRequest
 */
export type UpdateTemplateRequestJson = {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplateJson;
};

/**
 * Describes the message notification_templates.v1.UpdateTemplateRequest.
 * Use `create(UpdateTemplateRequestSchema)` to create a new message.
 */
export const UpdateTemplateRequestSchema: GenMessage<UpdateTemplateRequest, { jsonType: UpdateTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 5);

/**
 * @generated from message notification_templates.v1.UpdateTemplateResponse
 */
export type UpdateTemplateResponse = Message<"notification_templates.v1.UpdateTemplateResponse"> & {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplate;
};

/**
 * @generated from message notification_templates.v1.UpdateTemplateResponse
 */
export type UpdateTemplateResponseJson = {
	/**
	 * @generated from field: notification_templates.v1.NotificationTemplate template = 1;
	 */
	template?: NotificationTemplateJson;
};

/**
 * Describes the message notification_templates.v1.UpdateTemplateResponse.
 * Use `create(UpdateTemplateResponseSchema)` to create a new message.
 */
export const UpdateTemplateResponseSchema: GenMessage<UpdateTemplateResponse, { jsonType: UpdateTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 6);

/**
 * @generated from message notification_templates.v1.DeleteTemplateRequest
 */
export type DeleteTemplateRequest = Message<"notification_templates.v1.DeleteTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message notification_templates.v1.DeleteTemplateRequest
 */
export type DeleteTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message notification_templates.v1.DeleteTemplateRequest.
 * Use `create(DeleteTemplateRequestSchema)` to create a new message.
 */
export const DeleteTemplateRequestSchema: GenMessage<DeleteTemplateRequest, { jsonType: DeleteTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 7);

/**
 * @generated from message notification_templates.v1.DeleteTemplateResponse
 */
export type DeleteTemplateResponse = Message<"notification_templates.v1.DeleteTemplateResponse"> & {};

/**
 * @generated from message notification_templates.v1.DeleteTemplateResponse
 */
export type DeleteTemplateResponseJson = {};

/**
 * Describes the message notification_templates.v1.DeleteTemplateResponse.
 * Use `create(DeleteTemplateResponseSchema)` to create a new message.
 */
export const DeleteTemplateResponseSchema: GenMessage<DeleteTemplateResponse, { jsonType: DeleteTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 8);

/**
 * @generated from message notification_templates.v1.ListTemplatesRequest
 */
export type ListTemplatesRequest = Message<"notification_templates.v1.ListTemplatesRequest"> & {};

/**
 * @generated from message notification_templates.v1.ListTemplatesRequest
 */
export type ListTemplatesRequestJson = {};

/**
 * Describes the message notification_templates.v1.ListTemplatesRequest.
 * Use `create(ListTemplatesRequestSchema)` to create a new message.
 */
export const ListTemplatesRequestSchema: GenMessage<ListTemplatesRequest, { jsonType: ListTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 9);

/**
 * @generated from message notification_templates.v1.ListTemplatesResponse
 */
export type ListTemplatesResponse = Message<"notification_templates.v1.ListTemplatesResponse"> & {
	/**
	 * @generated from field: repeated notification_templates.v1.NotificationTemplate templates = 1;
	 */
	templates: NotificationTemplate[];
};

/**
 * @generated from message notification_templates.v1.ListTemplatesResponse
 */
export type ListTemplatesResponseJson = {
	/**
	 * @generated from field: repeated notification_templates.v1.NotificationTemplate templates = 1;
	 */
	templates?: NotificationTemplateJson[];
};

/**
 * Describes the message notification_templates.v1.ListTemplatesResponse.
 * Use `create(ListTemplatesResponseSchema)` to create a new message.
 */
export const ListTemplatesResponseSchema: GenMessage<ListTemplatesResponse, { jsonType: ListTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 10);

/**
 * @generated from message notification_templates.v1.RenderTemplateRequest
 */
export type RenderTemplateRequest = Message<"notification_templates.v1.RenderTemplateRequest"> & {
	/**
	 * @generated from oneof notification_templates.v1.RenderTemplateRequest.to_render
	 */
	toRender:
		| {
				/**
				 * @generated from field: string id = 1;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: string template = 2;
				 */
				value: string;
				case: "template";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: google.protobuf.Struct variables = 3;
	 */
	variables?: JsonObject;
};

/**
 * @generated from message notification_templates.v1.RenderTemplateRequest
 */
export type RenderTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string template = 2;
	 */
	template?: string;

	/**
	 * @generated from field: google.protobuf.Struct variables = 3;
	 */
	variables?: StructJson;
};

/**
 * Describes the message notification_templates.v1.RenderTemplateRequest.
 * Use `create(RenderTemplateRequestSchema)` to create a new message.
 */
export const RenderTemplateRequestSchema: GenMessage<RenderTemplateRequest, { jsonType: RenderTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 11);

/**
 * @generated from message notification_templates.v1.RenderTemplateResponse
 */
export type RenderTemplateResponse = Message<"notification_templates.v1.RenderTemplateResponse"> & {
	/**
	 * @generated from field: string rendered_content = 1;
	 */
	renderedContent: string;
};

/**
 * @generated from message notification_templates.v1.RenderTemplateResponse
 */
export type RenderTemplateResponseJson = {
	/**
	 * @generated from field: string rendered_content = 1;
	 */
	renderedContent?: string;
};

/**
 * Describes the message notification_templates.v1.RenderTemplateResponse.
 * Use `create(RenderTemplateResponseSchema)` to create a new message.
 */
export const RenderTemplateResponseSchema: GenMessage<RenderTemplateResponse, { jsonType: RenderTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 12);

/**
 * @generated from message notification_templates.v1.BatchRenderTemplateRequest
 */
export type BatchRenderTemplateRequest = Message<"notification_templates.v1.BatchRenderTemplateRequest"> & {
	/**
	 * @generated from field: repeated notification_templates.v1.RenderTemplateRequest requests = 1;
	 */
	requests: RenderTemplateRequest[];

	/**
	 * @generated from field: google.protobuf.Struct variables = 2;
	 */
	variables?: JsonObject;
};

/**
 * @generated from message notification_templates.v1.BatchRenderTemplateRequest
 */
export type BatchRenderTemplateRequestJson = {
	/**
	 * @generated from field: repeated notification_templates.v1.RenderTemplateRequest requests = 1;
	 */
	requests?: RenderTemplateRequestJson[];

	/**
	 * @generated from field: google.protobuf.Struct variables = 2;
	 */
	variables?: StructJson;
};

/**
 * Describes the message notification_templates.v1.BatchRenderTemplateRequest.
 * Use `create(BatchRenderTemplateRequestSchema)` to create a new message.
 */
export const BatchRenderTemplateRequestSchema: GenMessage<BatchRenderTemplateRequest, { jsonType: BatchRenderTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 13);

/**
 * @generated from message notification_templates.v1.BatchRenderTemplateResponse
 */
export type BatchRenderTemplateResponse = Message<"notification_templates.v1.BatchRenderTemplateResponse"> & {
	/**
	 * @generated from field: repeated string rendered_contents = 1;
	 */
	renderedContents: string[];
};

/**
 * @generated from message notification_templates.v1.BatchRenderTemplateResponse
 */
export type BatchRenderTemplateResponseJson = {
	/**
	 * @generated from field: repeated string rendered_contents = 1;
	 */
	renderedContents?: string[];
};

/**
 * Describes the message notification_templates.v1.BatchRenderTemplateResponse.
 * Use `create(BatchRenderTemplateResponseSchema)` to create a new message.
 */
export const BatchRenderTemplateResponseSchema: GenMessage<BatchRenderTemplateResponse, { jsonType: BatchRenderTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_notification_templates_v1_notification_templates, 14);

/**
 * @generated from service notification_templates.v1.NotificationTemplateService
 */
export const NotificationTemplateService: GenService<{
	/**
	 * @generated from rpc notification_templates.v1.NotificationTemplateService.GetTemplate
	 */
	getTemplate: {
		methodKind: "unary";
		input: typeof GetTemplateRequestSchema;
		output: typeof GetTemplateResponseSchema;
	};
	/**
	 * @generated from rpc notification_templates.v1.NotificationTemplateService.CreateTemplate
	 */
	createTemplate: {
		methodKind: "unary";
		input: typeof CreateTemplateRequestSchema;
		output: typeof CreateTemplateResponseSchema;
	};
	/**
	 * @generated from rpc notification_templates.v1.NotificationTemplateService.UpdateTemplate
	 */
	updateTemplate: {
		methodKind: "unary";
		input: typeof UpdateTemplateRequestSchema;
		output: typeof UpdateTemplateResponseSchema;
	};
	/**
	 * @generated from rpc notification_templates.v1.NotificationTemplateService.DeleteTemplate
	 */
	deleteTemplate: {
		methodKind: "unary";
		input: typeof DeleteTemplateRequestSchema;
		output: typeof DeleteTemplateResponseSchema;
	};
	/**
	 * @generated from rpc notification_templates.v1.NotificationTemplateService.ListTemplates
	 */
	listTemplates: {
		methodKind: "unary";
		input: typeof ListTemplatesRequestSchema;
		output: typeof ListTemplatesResponseSchema;
	};
	/**
	 * @generated from rpc notification_templates.v1.NotificationTemplateService.RenderTemplate
	 */
	renderTemplate: {
		methodKind: "unary";
		input: typeof RenderTemplateRequestSchema;
		output: typeof RenderTemplateResponseSchema;
	};
	/**
	 * @generated from rpc notification_templates.v1.NotificationTemplateService.BatchRenderTemplate
	 */
	batchRenderTemplate: {
		methodKind: "unary";
		input: typeof BatchRenderTemplateRequestSchema;
		output: typeof BatchRenderTemplateResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_notification_templates_v1_notification_templates, 0);
